import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import type { Router } from 'vue-router'
import { RouteConfig } from '@/hooks/useGameConfig'
import { useGoodsStore } from '@/store/modules/goodsStore'
import { useCommonStatus } from '@/store/modules/commonStaus'
import { useVoucherStore } from '@/store/modules/voucher'
import { CommonConstants } from '@/common/constants'
// import { AxiosCanceler } from '@/api/request/axiosCancel'

// const isProd = process.env.BASE_ENV === 'production'
const router = createRouter({
  history: CommonConstants.IS_CN
    ? createWebHashHistory(process.env.VUE_APP_BASE_ROUTE)
    : createWebHistory(process.env.VUE_APP_BASE_ROUTE),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: CommonConstants.IS_CN
        ? () => import('@/views/home/index.vue')
        : () => import('@/views/home/newHome.vue')
    },
    {
      path: '/',
      component: () => import('@/layouts/baseLayout.vue'),
      children: [
        {
          path: ':alias',
          name: 'Shop',
          component: () => import('@/views/mall/index.vue')
        }
      ]
    },
    {
      path: '/subAuth',
      name: 'SubAuth',
      component: () => import('@/views/mall/subProcess/index.vue')
    },
    {
      path: '/authFinish',
      name: 'AuthFinish',
      component: () => import('@/views/mall/subProcess/finish.vue')
    },
    {
      path: '/wechatPay',
      name: 'WechatPay',
      component: () => import('@/views/mall/payGoods/pcQrCode.vue')
    },
    {
      path: '/404', // 使用通配符匹配所有路由
      name: '404',
      component: () => import('@/views/404.vue')
    }
  ]
})

export default router

/**
 * 创建一个HTTP守卫，当路由切换时取消所有未完成的请求。
 * @param router - 路由对象。
 */
export function createHttpGuard(router: Router) {
  // 定义一个闭包，用来缓存AxiosCanceler的实例
  // Define a closure to cache the AxiosCanceler instance
  // const axiosCanceler: AxiosCanceler | null = null
  // 定义一个函数，根据项目配置返回是否需要移除所有未完成的HTTP请求的标志，并创建或销毁AxiosCanceler实例
  // Define a function that returns whether all pending HTTP requests need to be removed according to the project configuration, and creates or destroys the AxiosCanceler instance
  // function shouldCancelAllRequests() {
  //   const shouldCancelAllRequests = true
  //   if (shouldCancelAllRequests && !axiosCanceler) {
  //     // 如果需要移除，并且没有AxiosCanceler实例，则创建一个
  //     axiosCanceler = new AxiosCanceler()
  //   } else if (!shouldCancelAllRequests && axiosCanceler) {
  //     // 如果不需要移除，并且有AxiosCanceler实例，则销毁它
  //     axiosCanceler = null
  //   }
  //   return shouldCancelAllRequests
  // }

  router.beforeEach((to, from, next) => {
    // if (shouldCancelAllRequests() && axiosCanceler) {
    //   axiosCanceler.removeAllPending()
    // }
    const store = useGoodsStore()
    const storeSet = useCommonStatus()
    const storeVoucher = useVoucherStore()
    store.payVisible = false // 重置弹窗状态
    storeSet.voucherActivityVisible = false
    storeSet.limitRebateVisible = false
    storeSet.freeGiftSuccessVisible = false
    storeSet.wechatPayVisible = false
    storeSet.paySuccessVisible = false
    storeSet.activityCenterVisible = false
    storeVoucher.voucherCenterVisible = false

    if (to.name === 'Shop' && store.currentCartPath !== to.path) {
      store.currentCartPath = to.path
      store.cartGoodsList = []
    }

    if (to.name === 'Shop' && !RouteConfig.includes(to.path)) {
      //   访问404
      next({ name: '404' })
    }
    next()
  })
}
